<template>
  <div class="option-group-modal">
    <TextInput
      :id="inputs.name.id"
      :label="inputs.name.label"
      v-model="inputs.name.binding"
      :error="inputs.name.error"
      :rules="inputs.name.rules"
      :placeholder="inputs.name.placeholder"
      @validate="onValidate('name', $event)"
    />

    <TextInput
      :id="inputs.description.id"
      :label="inputs.description.label"
      v-model="inputs.description.binding"
      :error="inputs.description.error"
      :rules="inputs.description.rules"
      :placeholder="inputs.description.placeholder"
      @validate="onValidate('description', $event)"
    />

    <div class="modal__actions">
      <Btn variant="secondary" @click="handleCancel" type="button">Annuleren</Btn>
      <Btn variant="primary" @click="handleSubmit" type="button">
        {{ isEditing ? 'Wijzigingen opslaan' : 'Groep toevoegen' }}
      </Btn>
    </div>
  </div>
</template>

<script>
  import { computed, watch } from 'vue';
  import { useValidation } from '@/composables/useValidation';

  import TextInput from '@/components/inputs/TextInput.vue';
  import Btn from '@/components/partials/Btn.vue';

  export default {
    name: 'OptionGroupModal',

    components: {
      TextInput,
      Btn,
    },

    emits: ['submit', 'cancel'],

    props: {
      group: {
        type: Object,
        default: () => null,
        description: 'Group data for editing, null for new group',
      },
    },

    setup(props, { emit }) {
      const isEditing = computed(() => !!props.group);

      const { inputs, validateForm, onValidate } = useValidation({
        name: {
          id: 'group_name',
          label: 'Groep naam',
          binding: '',
          error: '',
          rules: ['required', 'maxLength:100'],
          placeholder: 'bijv. Afmetingen, Kleuren, Bediening',
        },
        description: {
          id: 'group_description',
          label: 'Beschrijving (optioneel)',
          binding: '',
          error: '',
          rules: ['maxLength:255'],
          placeholder: 'Korte beschrijving van deze groep',
        },
      });

      // Watch for group changes (when editing)
      watch(
        () => props.group,
        (newGroup) => {
          if (newGroup) {
            inputs.value.name.binding = newGroup.name || '';
            inputs.value.description.binding = newGroup.description || '';
          } else {
            inputs.value.name.binding = '';
            inputs.value.description.binding = '';
          }
        },
        { immediate: true }
      );

      const handleSubmit = async () => {
        const isValid = await validateForm();
        if (!isValid) {
          return;
        }

        emit('submit', {
          name: inputs.value.name.binding,
          description: inputs.value.description.binding,
          // Keep original name if editing (for renaming options)
          originalName: props.group?.name || null,
        });
      };

      const handleCancel = () => {
        emit('cancel');
      };

      return {
        inputs,
        onValidate,
        isEditing,
        handleSubmit,
        handleCancel,
      };
    },
  };
</script>

<style scoped lang="scss">
  .option-group-modal {
    display: flex;
    flex-direction: column;
    gap: 1rem;
  }

  .modal__actions {
    display: flex;
    justify-content: flex-end;
    gap: 0.75rem;
    padding-top: 1rem;
    border-top: 1px solid var(--slate-200);
  }
</style>
